
import { useState, useEffect } from 'react';

const TestimonialsSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  const testimonials = [
    {
      name: "Amina Benali",
      role: "Agent logistique chez Amazon",
      content: "Grâce à Wald Bladi, j'ai trouvé un emploi stable en moins de 2 semaines. L'équipe m'a accompagnée tout au long du processus et m'a aidée à préparer mes entretiens. Je recommande vivement leurs services !",
      rating: 5,
      image: "https://public.readdy.ai/ai/img_res/94cad7570e9cd20fdd5ca396e88cc2df.jpg"
    },
    {
      name: "Omar Khalil",
      role: "Opérateur de production chez Renault",
      content: "L'accompagnement personnalisé de Wald Bladi a fait toute la différence. Ils ont pris le temps de comprendre mes compétences et m'ont orienté vers le poste parfait. Aujourd'hui, je suis épanoui dans mon travail.",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20confident%20Arabic%20man%20in%20industrial%20work%20uniform%20smiling%20in%20modern%20factory%20setting%2C%20successful%20worker%20appearance%2C%20good%20lighting%2C%20representing%20career%20achievement%20and%20professional%20growth&width=150&height=150&seq=testimonial-2&orientation=squarish"
    },
    {
      name: "Fatima El Mansouri",
      role: "Aide-soignante au CHU de Rouen",
      content: "Après plusieurs mois de recherche infructueuse, Wald Bladi m'a redonné confiance. Leur approche bienveillante et leur connaissance du marché local m'ont permis de décrocher le poste de mes rêves dans le secteur de la santé.",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20caring%20Arabic%20woman%20healthcare%20worker%20in%20medical%20scrubs%20smiling%20in%20hospital%20environment%2C%20compassionate%20and%20professional%20appearance%2C%20bright%20medical%20setting%20representing%20healthcare%20career%20success&width=150&height=150&seq=testimonial-3&orientation=squarish"
    },
    {
      name: "Youssef Tazi",
      role: "Chauffeur livreur chez DHL",
      content: "Service exceptionnel ! L'équipe de Wald Bladi a su valoriser mon expérience et m'a trouvé un emploi qui correspond parfaitement à mes attentes. Le suivi post-embauche est également très apprécié.",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20Arabic%20man%20in%20delivery%20uniform%20standing%20next%20to%20delivery%20truck%2C%20confident%20and%20reliable%20appearance%2C%20outdoor%20professional%20setting%20representing%20transportation%20and%20logistics%20career&width=150&height=150&seq=testimonial-4&orientation=squarish"
    },
    {
      name: "Khadija Amrani",
      role: "Assistante administrative chez Mairie de Rouen",
      content: "Wald Bladi m'a aidée non seulement à trouver un emploi, mais aussi à comprendre les démarches administratives en France. Leur accompagnement va bien au-delà de la simple recherche d'emploi.",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20confident%20Arabic%20woman%20in%20office%20environment%20wearing%20professional%20attire%2C%20smiling%20warmly%2C%20modern%20administrative%20setting%2C%20representing%20public%20service%20career%20success&width=150&height=150&seq=testimonial-5&orientation=squarish"
    },
    {
      name: "Rachid Benkirane",
      role: "Technicien maintenance chez SNCF",
      content: "Excellent service ! J'ai été impressionné par leur professionnalisme et leur connaissance du marché de l'emploi local. Ils m'ont trouvé exactement ce que je cherchais dans le secteur technique.",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20skilled%20Arabic%20man%20in%20technical%20work%20uniform%20smiling%20in%20railway%20maintenance%20facility%2C%20confident%20technician%20appearance%2C%20industrial%20setting%20representing%20technical%20career%20achievement&width=150&height=150&seq=testimonial-6&orientation=squarish"
    }
  ];

  // Auto-play functionality
  useEffect(() => {
    if (isPlaying) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % testimonials.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [isPlaying, testimonials.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <section className="py-20 bg-gradient-to-br from-emerald-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Ils Nous Font Confiance
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Découvrez les témoignages de nos candidats qui ont trouvé leur emploi 
            grâce à notre accompagnement personnalisé
          </p>
        </div>

        {/* Testimonials Slider */}
        <div className="relative max-w-4xl mx-auto">
          {/* Main Slider Container */}
          <div className="relative overflow-hidden rounded-3xl bg-white shadow-2xl">
            <div 
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {testimonials.map((testimonial, index) => (
                <div key={index} className="w-full flex-shrink-0 p-8 md:p-12">
                  <div className="text-center">
                    {/* Quote icon */}
                    <div className="mb-6">
                      <i className="ri-double-quotes-r text-emerald-200 text-6xl"></i>
                    </div>

                    {/* Rating */}
                    <div className="flex justify-center space-x-1 mb-6">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                      ))}
                    </div>

                    {/* Content */}
                    <p className="text-gray-700 text-lg md:text-xl leading-relaxed mb-8 max-w-3xl mx-auto">
                      "{testimonial.content}"
                    </p>

                    {/* Author */}
                    <div className="flex items-center justify-center space-x-4">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="w-16 h-16 rounded-full object-cover object-top shadow-lg"
                      />
                      <div className="text-left">
                        <h4 className="font-bold text-gray-900 text-lg">{testimonial.name}</h4>
                        <p className="text-emerald-600 font-medium">{testimonial.role}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/90 hover:bg-white text-emerald-600 w-12 h-12 rounded-full shadow-lg flex items-center justify-center transition-all cursor-pointer z-10"
          >
            <i className="ri-arrow-left-line text-xl"></i>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/90 hover:bg-white text-emerald-600 w-12 h-12 rounded-full shadow-lg flex items-center justify-center transition-all cursor-pointer z-10"
          >
            <i className="ri-arrow-right-line text-xl"></i>
          </button>

          {/* Play/Pause Button */}
          <button
            onClick={() => setIsPlaying(!isPlaying)}
            className="absolute top-4 right-4 bg-white/90 hover:bg-white text-emerald-600 w-10 h-10 rounded-full shadow-lg flex items-center justify-center transition-all cursor-pointer z-10"
          >
            <i className={`${isPlaying ? 'ri-pause-line' : 'ri-play-line'} text-lg`}></i>
          </button>

          {/* Dots Navigation */}
          <div className="flex justify-center space-x-3 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  index === currentSlide 
                    ? 'bg-emerald-600 w-8' 
                    : 'bg-gray-300 hover:bg-emerald-300'
                }`}
              />
            ))}
          </div>

          {/* Progress Bar */}
          <div className="mt-4 max-w-md mx-auto">
            <div className="bg-gray-200 rounded-full h-1">
              <div 
                className="bg-emerald-600 h-1 rounded-full transition-all duration-300"
                style={{ width: `${((currentSlide + 1) / testimonials.length) * 100}%` }}
              />
            </div>
            <div className="text-center mt-2 text-sm text-gray-500">
              {currentSlide + 1} / {testimonials.length}
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <p className="text-gray-600 mb-6 text-lg">
            Rejoignez les centaines de personnes qui ont trouvé leur emploi avec nous
          </p>
          <button className="bg-emerald-600 text-white px-8 py-4 rounded-xl hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap shadow-lg text-lg font-semibold">
            <i className="ri-briefcase-line mr-2"></i>
            Commencer mon accompagnement
          </button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
